<template>
    <div class="msg">
        <div class="user-mes-box">
            <div class="user-mes-title" v-text="importHs"></div>
            <ul class="user-mes user-mes-p" v-show="loginHs">
                <li class="user-mes-in cle login-border">
                    <div class="login-icon fl">
                        <img :src="userLImg" alt="">
                    </div>
                    <input type="text" maxlength="32" v-model="user" class="user-mes-input fl user-mes-w">
                </li>
                <li class="user-mes-in cle login-border">
                    <div class="login-icon fl">
                        <img :src="pwdLImg" alt="">
                    </div>
                    <input type="password" maxlength="32" v-model="pwd" class="user-mes-input fl user-mes-w">
                </li>
                <li class="tip" v-text="importTip"></li>
                <li class="tip note" v-text="importNote"></li>
                <li class="tip" v-text="firstTip"></li>
                <li class="tip" v-text="secondTip"></li>
                <li class="tip" v-text="thirdTip"></li>
                <li class="user-mes-btn cle">
                    <button type="button" class="fl" @click="login" :title="loginText" v-text="loginText"></button>
                    <button type="button" class="fr" @click="cancle" :title="cancleText" v-text="cancleText"></button>
                </li>
            </ul>
            <div class="user-mes user-mes-p" v-show="listHs">
                <div class="user-mes-in device-list">
                    <ul class="list-box cle">
                        <li class="list-item-1 fl">
                            <input type="checkbox" v-model="checkAll" @change="checkedAll" name="" id="">
                        </li>
                        <li class="list-item-2 fl" :title="cID" v-text="cID"></li>
                        <li class="list-item-3 fl" :title="cName" v-text="cName"></li>
                    </ul>
                    <div class="list-content">
                        <ul class="list-box cle" v-for="(item,index) in device" :key="index">
                            <li class="list-item-1 fl">
                                <input type="checkbox" :disabled="item.disabled" :value="index" v-model="checked" @change="checkedIt" name="" id="">
                            </li>
                            <li class="list-item-2 fl" :title="item.UUID" v-text="item.UUID"></li>
                            <li class="list-item-3 fl" :title="item.NodeName" v-text="item.NodeName"></li>
                        </ul>
                    </div>
                </div>
                <div class="user-mes-btn cle" style="margin-top:10px;">
                    <button type="button" class="fl" @click="add" :disabled="checked.length?false:true" :title="addText" v-text="addText"></button>
                    <button type="button" class="fr" @click="cancle" :title="cancleText" v-text="cancleText"></button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import add from '../assets/js/bomb'
export default {
    name:'AddDeviceHs',
    props:['ocx'],
    data(){
        return {
            importHs:this.lanNow.lan["K170_Import"],
            loginHs:true,
            userLImg:'./static/img/userL.png',
            pwdLImg:'./static/img/pwdL.png',
            user:'',
            pwd:'',
            loginText:this.lanNow.lan["K008_Login"],
            cancleText:this.lanNow.lan["K018_Cancel"],
            device:[],
            listHs:false,
            all:this.lanNow.lan["K169_SelectAll"],
            addText:this.lanNow.lan["K170_Import"],
            cID:this.lanNow.lan["K004_CloudID"],
            cName:this.lanNow.lan["K023_DeviceName"],
            checkAll:false,
            checked:[],
            listTab:'',
            suc:0,
            err:0,
            importTip:this.lanNow.lan["K213_ImportTip"],
            importNote:this.lanNow.lan["K214_Note"],
            firstTip:this.lanNow.lan["K215_FirstTip"],
            secondTip:this.lanNow.lan["K216_SecondTip"],
            thirdTip:this.lanNow.lan["K217_ThirdTip"],
        }
    },
    methods:{
        login:function(){
            this.$emit('loadMsg',true);
            if(this.browserDetect() !== 'IE'){
                this.loginSet();
            }else{
                setTimeout(function(){
                    this.loginSet();
                }.bind(this),3000);
            };
        },
        loginSet:function(){
            if(this.browserDetect() !== 'IE'){
                if(this.socket.set.readyState===1){
                    this.socketObj.set[118]=function(res){
                        this.hsLogin(res[0]);
                    }.bind(this);
                    this.socket.set.send(this.jsonStr(118,[this.user,this.pwd]));
                }else{
                    this.$emit("loadMsg",false);
                };
            }else{
                try {
                    var rtn = this.ocx.LoginServer("qvcloud.net", 8300, this.user, this.pwd, "123", 0)-0;
                } catch (error) {
                    if(confirm(this.lanNow.lan['K149_plugIn'])){
                        window.open(this.baseData['Plug-in']);
                    };
                    this.$emit('loadMsg',false);
                    return false;
                };
                this.$emit('loadMsg',false);
                this.$nextTick(function(){
                    if (rtn !== 1){
                        alert(this.lanNow.lan["K171_Error"]);
                        return false;
                    }; 
                    this.loginHs=false;
                    this.listHs=true;
                    this.list();
                });
                
            };
        },
        hsLogin:function(rtn){
            this.$emit('loadMsg',false);
            if (rtn===''){
                alert(this.lanNow.lan["K171_Error"]);
                return false;
            };
            this.loginHs=false;
            this.listHs=true;
            this.socketObj.set[120]=function(res){
                this.list(res);
            }.bind(this);
            this.socket.set.send(this.jsonStr(120,[rtn]));
        },
        list:function(mes){
            this.$emit('list');
            if(this.browserDetect() !== 'IE'){
                var list=mes;
            }else{
                var get=this.ocx.GetDevListFromServer();
                var list=this.ocx.GetDevInfo();
            };
            if(typeof list==='string'){
                try {
                    list=JSON.parse(list);
                    var type=Object.prototype.toString.call(list);
                    if(!((/Array/).test(type))){
                        list=[];
                    };
                } catch (error) {
                    list=[];
                }
            }else if(typeof list==='object'){
                var type=Object.prototype.toString.call(list);
                if(!((/Array/).test(type))){
                    list=[];
                };
            }else if(typeof list==='undefined'){
                list=[];
            }else{
                list=[];
            };
            var arr=[];
            for(var i=0;i<this.listTab.length;i++){
                for(var j=0;j<this.listTab[i].length;j++){
                    arr.push(this.listTab[i][j].id);
                };
            };
            list.forEach(function(v){
                if(arr.indexOf(v.UUID)>=0||!(/^um/).test(v.UUID)){
                    v.disabled=true;
                }else{
                    v.disabled=false;
                };
            });
            this.device=list;
        },
        checkedAll:function(){
            this.$nextTick(function(){
                if(this.device.length===0){
                    return false;
                };
                this.checked=[];
                if(this.checkAll){
                    this.device.forEach(function(v,i){
                        if(v.disabled===false){
                            this.checked.push(i);
                        };
                    }.bind(this));
                };
            });
        },
        checkedIt:function(){
            this.$nextTick(function(){
                if(this.device.length&&this.checked.length===this.device.length){
                    this.checkAll=true;
                }else{
                    this.checkAll=false;
                };
            });
        },
        add:function(){
            this.ajaxH.repeat=this.addAfter;
            this.$emit('refresh');
        },
        addAfter:function(){
            this.$emit('loadMsg',true);
            this.suc=0;
            this.err=0;
            this.checked.forEach(function(v){
                var item=this.device[v];
                this.confirm(item.UUID,item.NodeName,item.Account,item.Pwd);
            }.bind(this));
        },
        confirm:function(id,name,user,pwd){
            // for(var i=0;i<this.listTab.length;i++){
            //     for(var j=0;j<this.listTab[i].length;j++){
            //         if(this.listTab[i][j].id===id){
            //             this.suc=this.suc+1;
            //             if(this.suc+this.err===this.checked.length){
            //                 this.$emit('loadMsg',false);
            //                 alert(this.lanNow.lan["K172_Success"]+':'+this.suc+','+this.lanNow.lan["K173_Fail"]+':'+this.err);
            //                 this.cancle();
            //             };
            //             return false;
            //         };
            //     };
            // };
            var sessionId=this.ajaxH.session;
            var oem=this.baseData.oem;
            var str=add.addDeviceSet({
                sessionId:sessionId,
                oem:oem,
                id:id,
                name:name,
                pwd:JSON.stringify({user:user,pwd:pwd})
            });
            var data=this.ajaxSet({
                ip:this.cloudName,
                type:'auth/user',
                xml:str
            });
            this.confirmResult(data.data);
        },
        confirmResult:function(data){
            if(!data){
                this.err=this.err+1;
            }else{
                var result=$(data).find('header').find('result').text()-0;
                if(result===0){
                    this.suc=this.suc+1;
                }else{
                    this.err=this.err+1;
                };
            };
            if(this.suc+this.err===this.checked.length){
                this.$emit('loadMsg',false);
                this.$nextTick(function(){
                    alert(this.lanNow.lan["K172_Success"]+':'+this.suc+','+this.lanNow.lan["K173_Fail"]+':'+this.err);
                    this.$emit('refresh');
                    // this.cancle();
                    this.login();
                    this.checkedAll();
                });
            };
        },
        cancle:function(){
            this.$emit('hide');
            this.loginHs=true;
            this.user='';
            this.pwd='';
            this.listHs=false;
            this.checkAll=false;
            this.device='';
            this.checked=[];
            this.suc=0;
            this.err=0;
        },
        exist:function(d){
            this.listTab=d;
        }
    }
}
</script>
<style scoped>
    .msg{
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background-color:rgba(0, 0, 0, .5);
    }
    .user-mes-box{
        width:430px;
        height:440px;
        background-color: #EFF2F9;
        font-size:12px;
        position:absolute;
        top:50%;
        left:50%;
        margin-top:-220px;
        margin-left:-215px;
    }
    .user-mes-title{
        width:100%;
        height:24px;
        line-height:24px;
        text-align: center;
        background-color: #364860;
        color:#fff;
    }
    .user-mes{
        width:100%;
        height:calc(100% - 24px);
        padding:20px;
        box-sizing: border-box;
    }
    .user-mes-p{
        padding:20px 40px;
    }
    .login-border{
        border: 1px solid #ccc;
        box-sizing: border-box;
    }
    .user-mes-in{
        width:100%;
        height:30px;
    }
    .user-mes-in+.user-mes-in{
        margin-top:10px;
    }
    .user-mes-name{
        width:120px;
        height:100%;
        line-height:30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .user-mes-input{
        width:calc(100% - 120px - 20px);
        height: 100%;
        box-sizing: border-box;
        border:1px solid #ccc;
        outline: none;
    }
    .user-mes-w{
        width:calc(100% - 40px);
        border:none;
        background-color: transparent;
    }
    .user-mes-btn{
        width:100%;
        height:30px;
        margin-top:30px;
    }
    .user-mes-btn button{
        width:80px;
        height:100%;
        background-color: #EFF2F9;
        box-sizing: border-box;
        border:1px solid #364860;
        outline: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .login-icon{
        width:40px;
        height:100%;
        text-align: center;
    }
    .login-icon img{
        margin-top:3px;
    }
    .check-top{
        margin-top:8px;
    }
    .check-text{
        line-height: 30px;
        margin-left:10px;
    }
    .device-list{
        height:calc(100% - 30px - 10px);
        border: 1px solid #ccc;
        box-sizing: border-box;
    }
    .list-box{
        width:100%;
        height:30px;
        border-bottom: 1px solid #ccc;
        box-sizing: border-box;
    }
    .list-item-1{
        width:30px;
        height:100%;
        line-height: 32px;
        text-align: center;
        vertical-align: middle;
    }
    .list-item-2{
        width:145px;
        height:100%;
        border-left: 1px solid #ccc;
        text-align: center;
        line-height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
        box-sizing: border-box;
    }
    .list-item-3{
        width:calc(100% - 30px - 145px);
        height:100%;
        border-left: 1px solid #ccc;
        text-align: center;
        line-height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
        box-sizing: border-box;
    }
    
    .list-content{
        width:100%;
        height:calc(100% - 30px);
        overflow: hidden;
        overflow-y:auto;
    }
    .tip{
        width:100%;
        margin-top: 10px;
    }
    .note{
        font-weight: bolder;
        font-size: 14px;
    }
</style>
<style scoped>
    @import '../assets/css/cloudPop.css';  
</style>


// WEBPACK FOOTER //
// src/components/AddDeviceHs.vue